import request from "@utils/request";

const CancelRecordService = {
    /**
     * 客户取消登记列表
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6411
     */
    queryList(data) {
        return request({
            url: "/service/mg/cancel-register/list",
            method: "POST",
            data
        });
    }
};

export default CancelRecordService;
